export default "__VITE_ASSET__B_3uJ$TP__"